import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './index.css';
import './assets/css/bootstrap.min.css'
import "../src/assets/plugins/fontawesome/css/fontawesome.min.css"
import "../src/assets/plugins/fontawesome/css/all.min.css"

import "../src/assets/plugins/feather/feather.css"

import "../src/assets/css/bootstrap-datetimepicker.min.css"

import "../src/assets/plugins/datatables/datatables.min.css"

import "../src/assets/css/style.css"

/* TailAdmin-inspired restyle — imported last so it overrides the base theme */
import "../src/assets/css/tailadmin-theme.css"

import App from './App';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SpeedInsights } from "@vercel/speed-insights/react"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
    <SpeedInsights />
    <ToastContainer/>
  </BrowserRouter>
    
);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    registration.unregister();
  });
}
